import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionMarca } from "../components/TableAministracionMarca";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook

import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageMarca = () => {
  const authProvider = useDynamicAuth(); // Usar el hook
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>

              <TableAdministracionMarca />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
